import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PaymentActions, ProjectsActions, authActions } from 'redux/actions';
import {
  SvgWrapper,
  Container,
  H1,
  Colors,
  isMobile,
  Modal,
  device,
  PrimaryButtonV2,
} from 'utils';
import { default as ShareProject } from './ShareProjct';
import { Header, Footer, Card } from 'components';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import config from 'config';
import { ThankYouImageNew, ThankYouImg } from 'images';
import ContactModal from 'scenes/Project/components/ContactModal';

const APP_URL = config.REACT_APP_URL;
const ThankYouWrapper = styled.div`
  text-align: center;
  margin-bottom: 100px;
  h1 {
    font-weight: bold;
    color: ${Colors.GreenColor};
    & + p {
      font-size: 22px;
      color: ${Colors.GreenColor};
    }
  }
  .actions {
    display: flex;
    justify-content: center;
    @media ${device.allMobile} {
      display: block;
    }
    a + button {
      margin-left: 20px;
      @media ${device.allMobile} {
        margin-left: 0;
      }
    }
  }
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #d5d7da;
  border-radius: 10px;
  margin-top: 32px;
  margin-bottom: 24px;
  padding: 32px;
  align-items: center;
  background: #e6f4d7;
`;

const ButtonText = styled.div`
  font-size: 16px;
  font-weight: 400;
  padding-top: 2px;
`;

class DraftSubmitted extends Component {
  componentDidMount() {
    const {
      resetDonation,
      project,
      showProject,
      sendSuccessURL,
      match: {
        params: { url },
      },
    } = this.props;

    resetDonation();
    if (project && project.url !== url) {
      showProject(url, true, true, true);
    }
    const session_string = this?.props?.location?.search;
    const session_id = session_string.split('=')[1];
    if (session_id) {
      sendSuccessURL(session_id);
    }
    this.handleSetProject();
    this.handleShowProjects();
  }

  static propTypes = {
    resetDonation: PropTypes.func.isRequired,
    showProject: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    sendSuccessURL: PropTypes.func,
    projects: PropTypes.object.isRequired,
    getProjects: PropTypes.func.isRequired,
  };
  state = {
    showModal: false,
    projectObj: {},
    perPage: 0,
    allProjectsIds: [],
    allProjects: [],
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.projects !== this.props.projects) {
      const cominedArr = this.state.allProjects.concat(
        this.props.projects.projects
      );
      const previousIds = cominedArr?.map((project) => project.id);
      this.setState({ allProjects: cominedArr });
      this.setState({ allProjectsIds: previousIds });
    }
  };

  handleSetMetaTags = () => {
    const { projectObj } = this.state;

    if (!projectObj) {
      return;
    }
    const { title, description, images } = projectObj;
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    // const ogImageTag = document.querySelector('meta[property="og:image"]');
    // const ogImageTagSecure = document.querySelector('meta[property="og:image:secure_url"]');
    const projectUrl = document.querySelector('meta[property="og:url"]');
    if (ogTitleTag && title) {
      ogTitleTag.setAttribute('content', title);
    }
    if (ogDescriptionTag && description) {
      ogDescriptionTag.setAttribute('content', description);
    }
    if (projectUrl) {
      const project_url = `${APP_URL}project/${
        projectObj?.url ? projectObj?.url : ''
      }`;
      projectUrl.setAttribute('content', project_url);
    }
    // if (ogImageTag && ogImageTagSecure && images && images.length > 0) {
    //   const projectImageURL = `${images[0]}`;
    //   if (ogImageTag) {
    //     ogImageTag.setAttribute('content', projectImageURL);
    //   }
    //   if (ogImageTagSecure) {
    //     ogImageTagSecure.setAttribute('content', projectImageURL);
    //   }
    // }
  };

  handleShowProjects = () => {
    const { getProjects } = this.props;
    const { perPage, allProjectsIds } = this.state;
    getProjects(perPage + 6, 1, allProjectsIds);
    this.setState({ perPage: perPage + 6 });
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };
  handleSetProject = () => {
    const project = JSON.parse(localStorage.getItem('projectDraft') || {});
    this.setState({ projectObj: project && project });
  };
  render() {
    const { showModal, projectObj, allProjects } = this.state;
    const { loading, project } = this.props;
    const projects = isMobile() ? allProjects.slice(0, 3) : allProjects;
    const user = localStorage.getItem('user');
    return (
      <>
        <ContactModal />
        <div>
          <Header relativeHeader={true} />
          <Container>
            <ThankYouWrapper>
              <BoxWrapper>
                <div>
                  <SvgWrapper
                    width={isMobile() ? '80%' : '500px'}
                    height={'auto'}
                    style={{ marginBottom: '32px' }}
                  >
                    <picture>
                      <img src={ThankYouImageNew} alt="thank-you-img" />
                    </picture>
                  </SvgWrapper>
                </div>

                {this.props?.location?.search?.includes('Ramdan2025') ? (
                  <H1>
                    'Deine tägliche Spende für Ramadan 2025 ist nun
                    eingerichtet!'
                  </H1>
                ) : (
                  <>
                    <H1
                      style={{
                        fontSize: '30px',
                        padding: '0',
                        marginBottom: '16px',
                      }}
                    >
                      Barak Allahu feek
                      {user?.first_name && ` ${user.first_name}`}. <br />
                      {projectObj.status === 'edit_pending' ? (
                        <>Deine Änderungen wurden eingereicht.</>
                      ) : (
                        <>Dein Projekt wurde eingereicht.</>
                      )}
                    </H1>
                  </>
                )}
                <p style={{ marginBottom: '16px' }}>
                  {this.props?.location?.search?.includes('Ramdan2025') ? (
                    <>
                      Die Community sagt Danke! <br />
                      Mit deinen täglichen Spenden sorgst du dafür, dass sich
                      großartige Ideen realisieren lassen. Motiviere auch andere
                      in deinem Netzwerk, täglich zu spenden, damit viele
                      Projekte in Deutschland nicht nur eine Idee bleiben,
                      sondern Wirklichkeit werden!
                    </>
                  ) : (
                    <div style={{ fontSize: '18px', margin: '0' }}>
                      Wir überprüfen nun deine Angaben innerhalb von 24 Stunden.{' '}
                      <br />
                      <span style={{ color: '#3F621A', fontWeight: 600 }}>
                        {projectObj.status === 'edit_pending' ? (
                          <>
                            Wichtig: Dein Projekt bleibt weiterhin online und
                            sichtbar – <br />
                            es ändert sich nichts, bis wir die Anpassungen
                            freigeben.
                          </>
                        ) : (
                          <>
                            Nutze die Zeit, um deine Marketing-Aktionen
                            vorzubereiten - <br />
                            so bist du startklar, sobald dein Projekt live geht.
                          </>
                        )}
                      </span>
                    </div>
                  )}
                </p>
                <p style={{ fontSize: '16px', marginBottom: '32px' }}>
                  In dringenden Fällen kannst du uns unter{' '}
                  <a
                    href="mailto:projekte@commonsplace.de"
                    style={{ fontWeight: 600, color: '#3F621A' }}
                  >
                    projekte@commonsplace.de
                  </a>
                  <br />
                  kontaktieren, um die Bearbeitungszeit zu verkürzen.
                </p>
                <div className="actions">
                  <a
                    href="https://blog.commonsplace.de/category/handbuch/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrimaryButtonV2 primary={true} minWidth={'167px'}>
                      <ButtonText>Zum CP-Handbuch</ButtonText>
                    </PrimaryButtonV2>
                  </a>
                  <a style={{ marginRight: '32px' }} />

                  {projectObj.status === 'edit_pending' &&
                  projectObj.basicInfo.url ? (
                    <Link to={`/project/${projectObj.basicInfo.url}`}>
                      <PrimaryButtonV2 minWidth={'194px'}>
                        <ButtonText>Zur Projektseite</ButtonText>
                      </PrimaryButtonV2>
                    </Link>
                  ) : (
                    <Link to={`/view/${projectObj.id}`}>
                      <PrimaryButtonV2 minWidth={'194px'}>
                        <ButtonText>Zur Projektvorschau</ButtonText>
                      </PrimaryButtonV2>
                    </Link>
                  )}
                </div>
              </BoxWrapper>
            </ThankYouWrapper>
          </Container>
          <Footer />
        </div>
        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <ShareProject
            subtitle={projectObj?.subtitle ? projectObj?.subtitle : ''}
            title={projectObj?.title ? projectObj?.title : ''}
            banner={projectObj?.banner ? projectObj?.banner : ''}
            url={`${APP_URL}project/${projectObj?.url ? projectObj?.url : ''}`}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, homeProjects, projects } = state.projects;
  return {
    project,
    loading,
    homeProjects,
    projects,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showProject: (url, noDonations, noUpdates, noRandomProjects) =>
    dispatch(
      ProjectsActions.showProject(url, noDonations, noUpdates, noRandomProjects)
    ),
  getProjects: (perPage, page, ids) =>
    dispatch(ProjectsActions.getProjects(perPage, page, ids)),
  resetDonation: () => dispatch(PaymentActions.resetDonation()),
  sendSuccessURL: (id) => dispatch(authActions.sendSuccessURL(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DraftSubmitted);
